@if (wishlists()?.length > 0) {
<div class="filter-list">
  @if (wishlists()?.length > 1) {
  <p class="filter-item">
    {{ 'dias.filter.Wish_list.count.text' | translate : { '0': wishlists()?.length } }}
  </p>
  } @else { } @for (wishlist of wishlists(); track wishlist) {
  <div class="filter-item custom-orderlist-link">
    <a [routerLink]="'/account/wishlists/' + wishlist.id" data-testing-id="wishlist-template-list-title">
      {{ wishlist.title }}
    </a>
    <div>
      @if (wishlist.items?.length) {
      <a class="btn-tool d-inline-flex align-top">
        <ish-product-add-to-basket
          ishProductContext
          [parts]="getParts(wishlist)"
          displayType="icon"
          cssClass="text-primary p-0"
        />
      </a>
      }
      <a
        class="btn-tool"
        title="{{ 'account.wishlist.list.remove' | translate }}"
        (click)="openDeleteConfirmationDialog(wishlist, deleteDialog)"
        data-testing-id="delete-wishlist-template"
      >
        <fa-icon [icon]="['fas', 'trash-alt']">R</fa-icon>
      </a>
    </div>
  </div>
  }
  <ish-modal-dialog
    #deleteDialog
    [options]="{
      titleText: 'undefined',
      confirmText: 'account.wishlists.delete_wishlist_dialog.delete_button.text' | translate,
      rejectText: 'account.wishlists.delete_wishlist_dialog.cancel_button.text' | translate
    }"
    (confirmed)="delete($event)"
  >
    {{ 'account.wishlists.delete_wishlist_dialog.are_you_sure_paragraph' | translate }}
  </ish-modal-dialog>
</div>
} @else {
<p class="filter-item" data-testing-id="emptyList">
  {{ 'account.wishlists.no_wishlists' | translate }}
</p>
}
